<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['dischargepatient']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-birthcertificate size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Birth Notification Form</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
                show-empty
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>Loading data...</strong></div></template>
              <template #empty><div class="text-center text-muted my-2"><strong>No data found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(patient)="data">
                {{ data.item.patient.name }}
              </template>
              <template #cell(patientid)="data">
                {{ data.item.patient.patient_id }}
              </template>
              <template #cell(patientct)="data">
                0{{ data.item.patient.telephone }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <router-link :to="{ path: '/printbirthcertificate', query: { id:data.item.id, }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> Print</router-link>
                <b-button @click="remove(data.item.id,data.item.patient.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Birth Certificates</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-birthcertificate" centered title="NEW BIRTH NOTIFICATION FORM" title-class="font-18" hide-footer>
        <form @submit.prevent="addCertificate">
          <div class="form-group mb-2">
            <label>Patient's Name</label>
              <multiselect v-model="patient" :options="visits" :custom-label="customLabel" label="name"></multiselect>
            </div>
            
            <div class="form-group mb-2">
            <label>Date of Birth</label>
            <input v-model="date_of_birth" type="date" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Time of Birth</label>
            <input v-model="time_of_birth" type="time" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>APGAR Score</label>
            <input v-model="score" type="text" class="form-control" />
            </div> 
            <div class="form-group mb-2">
            <label>Birth Weight</label>
            <input v-model="birth_weight" type="text" class="form-control" />
            </div> 
            <div class="form-group mb-2">
            <label>Maturity</label>
            <input v-model="maturity" type="text" class="form-control" />
            </div> 
            <div class="form-group mb-2">
            <label>Birth Defects</label>
            <input v-model="birth_defects" type="text" class="form-control" />
            </div> 
            <div class="form-group mb-2">
            <label>Comments</label>
            <input v-model="comment" type="text" class="form-control" />
            </div> 
            <div class="form-group mb-2">
            <label>Mother</label>
            <input v-model="mother" type="text" class="form-control" />
            </div>            
            <div class="form-group mb-2">
            <label>Father</label>
              <input v-model="father" type="text" class="form-control"/>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-birthcertificate')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="addSubmitting" >
                  <b-spinner v-if="addSubmitting" small class="align-middle me-1"></b-spinner>
                  <i v-else class="fas fa-check-circle"></i>
                  {{ addSubmitting ? 'Submitting...' : 'Submit' }}
                </b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-birthcertificate" centered title="Delete Certificate " title-class="font-18" hide-footer>
        <form @submit.prevent="removeCertificate">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Certificate for : <b>{{ patient }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-birthcertificate')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="deleteSubmitting" >
                  <b-spinner v-if="deleteSubmitting" small class="align-middle me-1"></b-spinner>
                  <i v-else class="fas fa-check-circle"></i>
                  {{ deleteSubmitting ? 'Deleting...' : 'YES' }}
                </b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {birthcertificateMethods, visitMethods, birthcertificateComputed, visitComputed } from "@/state/helpers";

export default {
  page: {
    title: "Birth Certificates",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Multiselect,Layout,PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "BIRTH NOTIFICATION FORM",
      items: [ {text: "Dashboard",to: "/",}, {text: "BIRTH NOTIFICATION FORM",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      addSubmitting: false,
      deleteSubmitting: false,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'patientid', label: 'Patient ID', visible: true },
          { key: 'patient', label: 'Patient Name', visible: true },
          { key: 'date_of_birth', label: 'Date of Birth', visible: true },
          // { key: 'unit_no', label: 'unit_no', visible: true },
          { key: 'time_of_birth', label: 'Time of Birth', visible: true },
          { key: 'score', label: 'APGAR Score', visible: true },
          { key: 'birth_weight', label: 'Birth Weight', visible: true },
          { key: 'maturity', label: 'Maturity', visible: true },
          { key: 'birth_defects', label: 'Birth Defects', visible: true },
          { key: 'comment', label: 'Comments', visible: true },
          { key: 'mother', label: 'Mother', visible: true },
          { key: 'father', label: 'Father', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      patient:'',
      father:'',
      date_of_birth:new Date().toLocaleDateString('fr-CA'),
      mother:'',
      comment:'',
      birth_defects:'',
      maturity:'',
      birth_weight:'',
      score:'',
      time_of_birth:'',

    };
  },
  computed: {
    ...birthcertificateComputed,
    ...visitComputed,
    List() { return this.birthcertificates.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.birthcertificates.map((d) => ({...d }))},
    IsBusy() { return this.isBusy; },
  },
  async mounted() {
    await this.loadBirthCertificates();
    this.fetchVisits();
    this.TotalRows = this.birthcertificates.length;
  },
  methods: {
    ...birthcertificateMethods,
    ...visitMethods,
    customLabel ({ patient_id, name, telephone }) {
      return `${patient_id} – ${name} – ${telephone}`
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async loadBirthCertificates() {
      this.isBusy = true;
      try {
        await this.fetchBirthCertificates();
        this.TotalRows = this.birthcertificates.length;
      } finally {
        this.isBusy = false;
      }
    },
    remove(id,patient){
      this.id=id;
      this.patient=patient;
      this.$bvModal.show('delete-birthcertificate')
    },
    async addCertificate() { 
      if (!this.patient || !this.patient.patient_id) {
        this.$toast.error("Select a patient before submitting");
        return;
      }

      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("date_of_birth", this.date_of_birth);
      formData.append("time_of_birth", this.time_of_birth);
      formData.append("score", this.score);
      formData.append("birth_weight", this.birth_weight);
      formData.append("maturity", this.maturity);
      formData.append("birth_defects", this.birth_defects);
      formData.append("comment", this.comment);
      formData.append("mother", this.mother);
      formData.append("father", this.father);
      let url = "/addbirthcertificate";
      this.addSubmitting = true;
      try {
        const response = await axios.post(url, formData);
        if (response.status == 200) {
          await this.loadBirthCertificates();
          this.fetchVisits();
          this.$bvModal.hide('new-birthcertificate');
          this.patient="";
          this.date_of_birth="";
          this.father="";
          this.mother="";
          this.time_of_birth="";
          this.score="";
          this.birth_weight="";
          this.maturity="";
          this.birth_defects="";
          this.comment="";
          this.$toast.success("New Patient Certificate Added");
        }
      } catch (error) {
        const message = error.response?.data?.message || "Failed to save birth certificate";
        this.$toast.error(message);
      } finally {
        this.addSubmitting = false;
      }
    },
   
    async removeCertificate() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removebirthcertificate";
      this.deleteSubmitting = true;
      try {
        const response = await axios.post(url, formData);
        if (response.status == 200) {
          await this.loadBirthCertificates();
          this.$bvModal.hide('delete-birthcertificate');
          this.$toast.error("Patient Certificate Deleted");
        }
      } catch (error) {
        const message = error.response?.data?.message || "Failed to delete birth certificate";
        this.$toast.error(message);
      } finally {
        this.deleteSubmitting = false;
      }
    },
  },
};
</script>
